module.exports = __webpack_public_path__ + "static/media/common-sprite.aa22e8e4.svg";